import { render, staticRenderFns } from "./SGPBotaoAdicionarNovoComponent.vue?vue&type=template&id=4d0e2d09"
import script from "./SGPBotaoAdicionarNovoComponent.vue?vue&type=script&lang=js"
export * from "./SGPBotaoAdicionarNovoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports